// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container__1x9Pw"};